import React, { useState } from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import tw from 'twin.macro';

const Tab = styled.div.attrs({
  className:
    'cursor-pointer border-b-2 border-solid border-gray-800 text-gray-800 text-sm font-semibold text-center',
})`
  min-width: 85px;
  line-height: 16px;
  font-size: 14px;

  &.selected {
    ${tw`text-primary border-primary`}
  }
  &:last-child {
    flex-grow: 1;
  }

  @media only screen and (max-width: 639px) {
    font-size: 11px;
    min-width: 70px;
    white-space: nowrap;
    min-width: ${(props) => props.width || 70}px;
  }
`;

const Tabs = ({ options, current, onChange }) => {
  const handleChange = (key) => () => {
    onChange(key);
  };

  return (
    <div className="flex mb-6 w-full">
      {options.map(({ key, label, width }) => (
        <Tab
          key={key}
          className={cx('py-2', key === current && 'selected')}
          width={width}
          onClick={handleChange(key)}
        >
          {label}
        </Tab>
      ))}
      <Tab className="p-0 sm:hidden" />
    </div>
  );
};

export default Tabs;
